var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useForm, Head } from '@inertiajs/react';
import classNames from 'classnames';
import { useRoute } from 'ziggy-js';
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard';
import JetButton from '@/Jetstream/Button';
import JetInput from '@/Jetstream/Input';
import JetLabel from '@/Jetstream/Label';
import JetValidationErrors from '@/Jetstream/ValidationErrors';
import { Ziggy } from "@/ziggy";
export default function ForgotPassword(props) {
    var route = useRoute(Ziggy);
    var form = useForm({
        email: '',
    });
    function onSubmit(e) {
        e.preventDefault();
        form.post(route('password.email'));
    }
    return (_jsxs(JetAuthenticationCard, { children: [_jsx(Head, { title: "Forgot password | OVForm" }), _jsx("div", __assign({ className: "mb-4 text-sm text-gray-600" }, { children: "Forgot your password? No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one." })), props.status && (_jsx("div", __assign({ className: "mb-4 font-medium text-sm text-green-600" }, { children: props.status }))), _jsx(JetValidationErrors, { className: "mb-4" }), _jsxs("form", __assign({ onSubmit: onSubmit }, { children: [_jsxs("div", { children: [_jsx(JetLabel, __assign({ htmlFor: "email" }, { children: "Email" })), _jsx(JetInput, { id: "email", type: "email", className: "mt-1 block w-full", value: form.data.email, onChange: function (e) { return form.setData('email', e.currentTarget.value); }, required: true, autoFocus: true })] }), _jsx("div", __assign({ className: "flex items-center justify-end mt-4" }, { children: _jsx(JetButton, __assign({ className: classNames({ 'opacity-25': form.processing }), disabled: form.processing }, { children: "Email password reset link" })) }))] }))] }));
}
